<app-base-grid-template gridTitle="Offerings" (showDeletedClick)="onShowDeletedToggled($event)" [showAddButton]="true" (addButtonClick)="onAddButtonClicked()" (filterTextChange)="onFilterTextChanged($event)" (resetGridClick)="onResetGridClicked()" (exportGridClick)="onExportGridClicked()">
  <app-base-grid-header-template>
      <span class="mr-1">
        <button mat-flat-button color="primary" (click)="onManageOfferingCategoriesClicked()" class="mr-1">Manage Categories</button>
      </span>
  </app-base-grid-header-template>
  <app-base-grid-content-template>
    <ag-grid-angular *ngIf="gridOptions"
                     class="ag-theme-alpine"
                     [gridOptions]="gridOptions">
    </ag-grid-angular>
  </app-base-grid-content-template>
</app-base-grid-template>



